export default (input) => {
  return {
    ...input,
    sharingServicesCollection: input.sharingServicesCollection.map((service) => {
      return {
        ...service,
        shareName: service.shareName === 'Twitter' ? 'X' : service.shareName
      };
    })
  };
};
